import { demoFile, component, story, CLICK, POPUP } from "system/demo";
import { CommunityGuidelines } from 'feature/question/community-guidelines';

demoFile('feature/question/community-guidelines', {
    designUrl: 'https://www.figma.com/design/qbH103GBR3McZqhUp7O9fA/Onboarding-%26-Login-%26-Community-Guidelines---Testing?node-id=0-1&node-type=canvas&t=DtLdd9yzAlEsyXKd-0'
});

component('Community Guidelines', CommunityGuidelines, {}, [
    story('Open and Close Guidelines', [
        CLICK('Community Guidelines'),
        POPUP(CLICK('close-modal'))
    ])
]);
